import React, { useState } from "react";
import MaterialInput from "../../../components/MaterialInput";
import Grid from "@mui/material/Grid2";
import { FormControl, FormHelperText, Icon } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { useParams, useNavigate } from "react-router-dom";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";
import { useLoading } from "../../../context/LodingContext";
import MaterialButton from "../../../components/MaterialButton";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


const CHANGE_PASSWORD = gql`
  mutation ResetPassword($uid: String!, $token: String!, $newPassword: String!) {
  resetPassword(uid: $uid, token: $token, newPassword: $newPassword) {
    success
    message
    error
  }
}

`;
const ResetPassword = () => {
  
  const [viewPassword, setViewPassword] = useState(false);
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();
  const { circleLoading, setCirleLoading } = useLoading();
  const [passWordValues, setPassWordValues] = useState({
    newPassword1: "",
    newPassword2: "",
  });

  const { uid, token } = useParams();
  const navigate = useNavigate();


  
  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };

  const handlesend = async (e) => {
    e.preventDefault();
    setCirleLoading(true);
    try {

      const res = await request(BASEURL, CHANGE_PASSWORD, {
        token: token,
        newPassword: passWordValues.newPassword1,
        uid : uid
        // newPassword2: passWordValues.newPassword2,
      });

      if (res?.resetPassword?.success === true) {
        setSuccessStatus(true);
        setSucessTitle("New Password updated");
        setTimeout(() => {
          setSuccessStatus(false);
          navigate("/sign-in");
        }, 2000);
      }
      else {
        const errMessage = res?.resetPassword?.error
        setErrorStatus(true);
        setErrormessage(errMessage);
        setTimeout(() => {
          setErrorStatus(false);
        }, 3000);
      }

    } catch (error) {
      console.error(error);
      setErrorStatus(true);
      setErrormessage("Sorry, Network Error");
      setTimeout(() => {
        setErrorStatus(false);
      }, 3000);
    }
    finally {
      setCirleLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...passWordValues, [name]: value };

    if (name === "newPassword1" || name === "newPassword2") {
      const pw1 = name === "newPassword1" ? value : updated.newPassword1;
      const pw2 = name === "newPassword2" ? value : updated.newPassword2;

      if (pw1.length >= 8 && pw2.length >= 8) {
        updated.status = pw1 === pw2 ? "success" : "error";
        
      } else {
        updated.status = "";
        
      }
    }

    setPassWordValues(updated);
  };

const validatePasswordForm = (values) => {
    const password1 = values.newPassword1 || '';
    const password2 = values.newPassword2 || '';

    const isMinLength = password1.length >= 8;
    const isMatch = password1 === password2 && !!password1 && !!password2;
    const hasLetter = /[A-Za-z]/.test(password1);
    const hasNumber = /\d/.test(password1);
    const hasSpecialChar = /[^A-Za-z0-9]/.test(password1);

    return isMinLength && isMatch && hasLetter && hasNumber && hasSpecialChar;
  };

  return (
    <div className="form-layout">
      <div class="form-container">
        <div class="logo-container">Reset Password</div>
        <Grid size={{ xs: 12, sm: 12 }}>
          <label for="email">New Password</label>
          <MaterialInput
            fullWidth
            placeholder="Password"
            name="newPassword1"
            type={viewPassword ? "text" : "password"}
            onChange={handleChange}
            icon={
              viewPassword
                ? {
                  direction: "right",
                  component: (
                    <Icon color="action" fontSize="small">
                      <VisibilityOffIcon
                        onClick={handlePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      />
                    </Icon>
                  ),
                }
                : {
                  direction: "right",
                  component: (
                    <Icon color="action" fontSize="small">
                      <VisibilityIcon
                        onClick={handlePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      />
                    </Icon>
                  ),
                }
            }
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 12 }}>
          <label for="email">Confirm Password</label>
          <MaterialInput
            fullWidth
            placeholder="Password"
            name="newPassword2"
            type={viewPassword ? "text" : "password"}
            // variant="outlined"
            // value={signInData.password}
            onChange={handleChange}
            // error={signInData.passwordStatus === "error" ? true : false}
            // success={
            //   signInData.passwordStatus === "success" ? true : false
            // }
            icon={
              viewPassword
                ? {
                  direction: "right",
                  component: (
                    <Icon color="action" fontSize="small">
                      <VisibilityOffIcon
                        onClick={handlePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      />
                    </Icon>
                  ),
                }
                : {
                  direction: "right",
                  component: (
                    <Icon color="action" fontSize="small">
                      <VisibilityIcon
                        onClick={handlePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      />
                    </Icon>
                  ),
                }
            }
          />
      
        </Grid>
          <div style={{ marginLeft: "20px" }}>
            <ul style={{ paddingLeft: "0", margin: 0, listStyle: "none" }}>
              {[
                {
                  label: "Must be minimum 8 characters long",
                  condition: passWordValues.newPassword1?.length >= 8,
                },
                {
                  label: "Passwords must match each other",
                  condition:
                    passWordValues.newPassword1 === passWordValues.newPassword2 &&
                    Boolean(passWordValues.newPassword1) &&
                    Boolean(passWordValues.newPassword2),
                },
                {
                  label: "Should have at least one letter",
                  condition: /[A-Za-z]/.test(passWordValues.newPassword1 || ''),
                },
                {
                  label: "Should have at least one number",
                  condition: /[0-9]/.test(passWordValues.newPassword1 || ''),
                },
                {
                  label: "At least one special character",
                  condition: /[^A-Za-z0-9]/.test(passWordValues.newPassword1 || ''),
                },
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", marginBottom: 2 }}>
                  <span style={{ width: 24, display: "flex", justifyContent: "right" }}>
                    {item.condition ? (
                      <CheckCircleIcon fontSize="small" sx={{ color: 'green' }} />
                    ) : (
                      <CancelIcon fontSize="small" sx={{ color: 'red' }} />
                    )}
                  </span>
                  <FormControl
                    error={!item.condition}
                    sx={{
                      ...(item.condition && {
                        '& .MuiFormHelperText-root': { color: 'green' },
                      }),
                    }}
                  >
                    <FormHelperText>{item.label}</FormHelperText>
                  </FormControl>
                </li>
              ))}
            </ul>
          </div>

        <MaterialButton
          onClick={(e) => handlesend(e)}
          // class="form-submit-btn"
          variant="gradient"
          color="dark"
          disabled={!validatePasswordForm(passWordValues)}
        >
          Confirm
        </MaterialButton>
      </div>
    </div>
  );
};

export default ResetPassword;
